import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import ProgressRow from "../common/ProgressRow";
import InlineBarChart from "../charts/InlineBarChart";
import { fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";
import { moduleUsageData } from "../../data/dashboardMockData";

const MODULE_COLORS = [T.blue, T.green, T.teal, T.orange, T.purple];

const ModuleUsageSection = ({ loading }) => (
  <Col xl={6} className="d-flex">
    <DashPanel title="Module Usage" icon="bx bx-layer" iconColor={T.purple} loading={loading}>
      <SectionTitle>Weekly Sessions</SectionTitle>
      <InlineBarChart
        data={moduleUsageData.weeklyUsage}
        labelKey="day"
        valueKey="sessions"
        color={T.blue}
        formatValue={(v) => fmtNum(v)}
        loading={loading}
      />

      <SectionTitle style={{ marginTop: "14px" }}>Most Used Modules</SectionTitle>
      {moduleUsageData.mostUsed.map((m, i) => (
        <ProgressRow
          key={i}
          label={m.module}
          value={fmtNum(m.hits)}
          max={100}
          rawPct={Math.round((m.hits / moduleUsageData.mostUsed[0].hits) * 100)}
          color={MODULE_COLORS[i % 5]}
          badge={`${m.avgDailyUsers} users/day`}
          loading={loading}
        />
      ))}

      <SectionTitle style={{ marginTop: "12px" }}>Least Used Modules</SectionTitle>
      {moduleUsageData.leastUsed.map((m, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "5px 0",
            borderBottom: "1px solid #f1f3f5",
            fontSize: "12px",
          }}
        >
          <span style={{ color: T.text }}>{m.module}</span>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <span style={{ color: T.muted }}>{fmtNum(m.hits)} hits</span>
            <span
              style={{
                fontSize: "10px",
                padding: "1px 6px",
                borderRadius: "10px",
                background: "#fde8e8",
                color: T.red,
                fontWeight: 600,
              }}
            >
              {m.avgDailyUsers} users/day
            </span>
          </div>
        </div>
      ))}
    </DashPanel>
  </Col>
);

export default ModuleUsageSection;
